import { render, staticRenderFns } from "./CommunicationsView.vue?vue&type=template&id=28eb61e8&scoped=true"
import script from "./CommunicationsView.vue?vue&type=script&lang=js"
export * from "./CommunicationsView.vue?vue&type=script&lang=js"
import style0 from "./CommunicationsView.vue?vue&type=style&index=0&id=28eb61e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb61e8",
  null
  
)

export default component.exports